import HsocCreditsExplainer from 'pricing-pages-ui-components/hsoc-credits-explainer/HsocCreditsExplainer';
import { useCallback } from 'react';
import { useTrackSectionViewed } from '../../hooks/useTrackSectionViewed';
import { Screens } from '../../types/PublicNavItem';
import { TRACKING_SOURCES, trackClickedLink, trackImageInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const trackingSource = TRACKING_SOURCES.CREDITS_EXPLAINER;
const DEFAULT_AGENTS = ['customer', 'prospecting', 'data'];
export const HsocCreditsExplainerSection = () => {
  const sectionRef = useTrackSectionViewed(trackingSource, Screens.FLEX_SEATS_AND_CREDITS);
  const handleLinkClick = useCallback(props => {
    trackClickedLink(Object.assign({}, props, {
      trackingSource,
      screen: Screens.FLEX_SEATS_AND_CREDITS
    }));
  }, []);
  const handleCarouselClick = useCallback((index, direction) => {
    var _DEFAULT_AGENTS$index;
    trackImageInteraction({
      action: direction === 'next' ? 'clicked-carousel-next' : 'clicked-carousel-previous',
      name: (_DEFAULT_AGENTS$index = DEFAULT_AGENTS[index]) !== null && _DEFAULT_AGENTS$index !== void 0 ? _DEFAULT_AGENTS$index : '',
      trackingSource,
      screen: Screens.FLEX_SEATS_AND_CREDITS
    });
  }, []);
  const handleCarouselScroll = useCallback((index, direction) => {
    var _DEFAULT_AGENTS$index2;
    trackImageInteraction({
      action: direction === 'next' ? 'swiped-carousel-next' : 'swiped-carousel-previous',
      name: (_DEFAULT_AGENTS$index2 = DEFAULT_AGENTS[index]) !== null && _DEFAULT_AGENTS$index2 !== void 0 ? _DEFAULT_AGENTS$index2 : '',
      trackingSource,
      screen: Screens.FLEX_SEATS_AND_CREDITS
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    ref: sectionRef,
    children: /*#__PURE__*/_jsx(HsocCreditsExplainer, {
      agents: DEFAULT_AGENTS,
      onLinkClick: handleLinkClick,
      onCarouselClick: handleCarouselClick,
      onCarouselScroll: handleCarouselScroll
    })
  });
};
export default HsocCreditsExplainerSection;